import { EnumRankingType, IRankingData } from "src/components/common/ranking/types";
import { EnumFigureType, IFigure } from "src/types/common";

const FIGURE_TYPE_TO_RANKING_TYPE_MAP: Record<EnumFigureType, IRankingData["type"]> = {
    [EnumFigureType.Performance]: EnumRankingType.Performance,
    [EnumFigureType.MaxLoss]: EnumRankingType.MaxLoss,
    [EnumFigureType.InvestedCapital]: EnumRankingType.InvestedCapital,
    [EnumFigureType.SharpRatio]: EnumRankingType.SharpRatio,
    [EnumFigureType.RankingPlace]: EnumRankingType.RankingPlace,
    [EnumFigureType.LiquidationFigure]: EnumRankingType.LiquidationFigure,
    [EnumFigureType.TradingVolume]: EnumRankingType.TradingVolume,
    [EnumFigureType.Reservations]: EnumRankingType.Reservations,
    [EnumFigureType.Volatility]: EnumRankingType.Volatility,
    [EnumFigureType.Date]: EnumRankingType.Date,
    // No EnumRankingType variant exists; CardRankings.getValue() handles these
    // before this fallback is ever rendered.
    [EnumFigureType.Isin]: EnumRankingType.Performance,
    [EnumFigureType.Price]: EnumRankingType.Performance,
    [EnumFigureType.PerformanceFee]: EnumRankingType.Performance,
};

// Note: This one was created mainly for extended search page. Might not work with other components
export const translateFigureToRanking = (figure: IFigure): IRankingData => {
    const convertedValue = figure.value !== "" ? Number(figure.value?.replace(",", ".")) : null;

    return {
        ...figure,
        place: figure.type == EnumFigureType.RankingPlace ? Number(figure.value) : undefined,
        label: figure.label || "",
        value: Number.isNaN(convertedValue) ? figure.value : convertedValue,
        type: FIGURE_TYPE_TO_RANKING_TYPE_MAP[figure.type] || EnumRankingType.Performance,
    } as unknown as IRankingData;
};
